import React from 'react';
import LazyActionDrawerCell from '../components/cells/lazy-cells/LazyActionDrawerCell';
import LazyCollectorCell from '../components/cells/lazy-cells/LazyCollectorCell';
import LazyCollectionPriorityCell from '../components/cells/lazy-cells/LazyCollectionPriorityCell';
import LazyCompanyProfileCell from '../components/cells/lazy-cells/LazyCompanyProfileCell';
import LazyFolioInvoiceProfileCell from '../components/cells/lazy-cells/LazyFolioInvoiceProfileCell';
import OperationalAlertsArray from '../components/cells/OperationalAlertsArray';
import DrawerHeader from '../components/drawer/DrawerHeader';
import CollectionActions from '../components/drawer/CollectionActions';

export const LAZY_QUERIES_NAMES = {
  invoicesMasterEntityFields: { queryKey: 'invoicesMasterEntityFields', queryName: 'getMasterEntities' },
  invoicesReceiverFields: { queryKey: 'invoicesReceiverFields', queryName: 'staffMasterEntities' },
  invoicesCollectionFields: { queryKey: 'invoicesCollectionFields', queryName: 'invoices' },
  invoiceRequirementsFields: { queryKey: 'invoiceRequirementsFields', queryName: 'invoices' },
  invoiceDocumentFinanceStateFields: {
    queryKey: 'invoiceDocumentFinanceStateFields',
    queryName: 'invoices',
  },
  invoiceDocumentFinanceStateDetailFields: {
    queryKey: 'invoiceDocumentFinanceStateDetailFields',
    queryName: 'invoices',
  },
  myOffersCommercialDocumentFinanceStateFields: {
    queryKey: 'myOffersCommercialDocumentFinanceStateFields',
    queryName: 'myOffersCommercial',
  },
  ratificationManagerFields: {
    queryKey: 'ratificationManagerFields',
    queryName: 'getRatificationManagers',
  },
};

const useInvoiceLazyColumns = (showDicom = true, receiverType = 'receiver') => [
  {
    field: 'lazyCompanyProfile',
    orderByField: 'company',
    headerName: 'Emisor',
    type: 'string',
    sortable: true,
    minWidth: 100,
    flex: 2,
    useAdditionalQueries: true,
    queryField: LAZY_QUERIES_NAMES.invoicesMasterEntityFields.queryKey,
    renderCell: (params) => (
      <LazyCompanyProfileCell
        lazyCellProps={{
          rowId: params.row.companyId,
          queryKey: LAZY_QUERIES_NAMES.invoicesMasterEntityFields.queryKey,
          queryName: LAZY_QUERIES_NAMES.invoicesMasterEntityFields.queryName,
          additionalQueriesResults: params.additionalQueriesResults,
        }}
        companyProfileCellProps={{
          showDicom,
          type: 'company',
        }}
      />
    ),
  },
  {
    field: 'lazyReceiverSortable',
    headerName: 'Receptor',
    orderByField: 'rut_receiver',
    type: 'string',
    sortable: true,
    minWidth: 150,
    flex: 2,
    useAdditionalQueries: true,
    queryField: LAZY_QUERIES_NAMES.invoicesReceiverFields.queryKey,
    renderCell: (params) => (
      <LazyCompanyProfileCell
        lazyCellProps={{
          rowId: params.row.receiverId,
          queryKey: LAZY_QUERIES_NAMES.invoicesReceiverFields.queryKey,
          queryName: LAZY_QUERIES_NAMES.invoicesReceiverFields.queryName,
          additionalQueriesResults: params.additionalQueriesResults,
        }}
        companyProfileCellProps={{
          showDicom,
          type: receiverType,
          debtsShowType: null,
        }}
      />
    ),
  },
  {
    field: 'lazyActionsDrawer',
    headerName: 'Gestiones',
    type: 'string',
    sortable: false,
    filterable: false,
    width: 100,
    minWidth: 100,
    align: 'center',
    flex: 1,
    useAdditionalQueries: true,
    queryField: LAZY_QUERIES_NAMES.invoicesCollectionFields.queryKey,
    renderCell: (params) => (
      <LazyActionDrawerCell
        lazyCellProps={{
          rowId: params.row.id,
          queryKey: LAZY_QUERIES_NAMES.invoicesCollectionFields.queryKey,
          queryName: LAZY_QUERIES_NAMES.invoicesCollectionFields.queryName,
          additionalQueriesResults: params.additionalQueriesResults,
        }}
        actionDrawerCellProps={{
          headerComponent: DrawerHeader,
          contentComponent: CollectionActions,
          receiverId: params.row.receiverId,
          useAdditionalQuery: true,
          onAdditionalDataLoaded: (data) => data.collectionActions.edges.map((edge) => edge.node),
        }}
        hasMultipleManagers={false}
      />
    ),
  },
  {
    field: 'lazyCollector',
    headerName: 'Cobrador/a',
    type: 'string',
    sortable: false,
    filterable: false,
    width: 100,
    minWidth: 100,
    align: 'center',
    useAdditionalQueries: true,
    queryField: LAZY_QUERIES_NAMES.invoicesCollectionFields.queryKey,
    renderCell: (params) => (
      <LazyCollectorCell
        lazyCellProps={{
          rowId: params.row.id,
          queryKey: LAZY_QUERIES_NAMES.invoicesCollectionFields.queryKey,
          queryName: LAZY_QUERIES_NAMES.invoicesCollectionFields.queryName,
          additionalQueriesResults: params.additionalQueriesResults,
        }}
      />
    ),
  },
  {
    field: 'lazyCollectionPriority',
    headerName: 'Prioridad',
    type: 'string',
    sortable: true,
    filterable: true,
    maxWidth: 80,
    minWidth: 80,
    align: 'center',
    flex: 1,
    useAdditionalQueries: true,
    queryField: LAZY_QUERIES_NAMES.invoicesCollectionFields.queryKey,
    renderCell: (params) => (
      <LazyCollectionPriorityCell
        lazyCellProps={{
          rowId: params.row.id,
          queryKey: LAZY_QUERIES_NAMES.invoicesCollectionFields.queryKey,
          queryName: LAZY_QUERIES_NAMES.invoicesCollectionFields.queryName,
          additionalQueriesResults: params.additionalQueriesResults,
        }}
      />
    ),
  },
  {
    field: 'lazyFolioInvoiceProfile',
    headerName: 'Folio',
    type: 'string',
    sortable: false,
    filterable: false,
    minWidth: 90,
    flex: 1,
    useAdditionalQueries: true,
    queryField: LAZY_QUERIES_NAMES.invoicesCollectionFields.queryKey,
    renderCell: (params) => (
      <LazyFolioInvoiceProfileCell
        lazyCellProps={{
          rowId: params.row.id,
          queryKey: LAZY_QUERIES_NAMES.invoicesCollectionFields.queryKey,
          queryName: LAZY_QUERIES_NAMES.invoicesCollectionFields.queryName,
          additionalQueriesResults: params.additionalQueriesResults,
          showPartialResult: true,
        }}
        folioInvoiceProfileCellProps={{
          invoice: params.row,
          AlertsArray: OperationalAlertsArray,
          useLoadingAlerts: true,
        }}
      />
    ),
  },
];

export default useInvoiceLazyColumns;
